import { isArray, isNil, isObject } from 'lodash-es';
import murmurHash3 from 'murmurhash3js';

/**
 * @returns 52-bit integer
 */
export const murmurhash3 = function (str: string, seed = 0): number {
  const hex = murmurHash3.x64.hash128(str, seed);
  return parseInt(hex.slice(-13), 16);
};

type NestedValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | GeoJSON.Geometry
  | NestedObject
  | NestedArray;
type NestedArray = NestedValue[];
type NestedObject = { [key: string]: NestedValue };

/**
 * @note
 * This function sorts the arrays contents as well but will not process the
 * objects within those arrays.
 */
function sortObject(obj: NestedValue): NestedValue {
  if (isNil(obj) || !isObject(obj)) {
    return obj;
  }

  if (isArray(obj)) {
    const sortedArray = (obj as NestedArray).map(sortObject) as NestedArray;
    return sortedArray.sort();
  }

  const sortedKeys = Object.keys(obj as NestedObject).sort();
  const result: NestedObject = {};
  sortedKeys.forEach((key) => {
    result[key] = sortObject((obj as NestedObject)[key]);
  });

  return result;
}

export function hashObject(obj: object): number {
  const str = JSON.stringify(obj);
  const hash = murmurhash3(str);

  return hash;
}

export function hashSortedObject(obj: NestedObject): number {
  const sortedObject = sortObject(obj);
  const str = JSON.stringify(sortedObject);
  const hash = murmurhash3(str);

  return hash;
}

export function hashSHA256(string: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(string);
  return crypto.subtle.digest('SHA-256', data).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  });
}
